var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMicrosoftTeamsLogo = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34680_2336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6602 5.625H15.793C16.1835 5.625 16.5 5.94399 16.5 6.3375V10.1314C16.5 11.5776 15.3367 12.75 13.9017 12.75H13.8894C12.4544 12.7502 11.2909 11.578 11.2907 10.1317C11.2907 10.1316 11.2907 10.1315 11.2907 10.1314V5.99738C11.2907 5.79172 11.4561 5.625 11.6602 5.625Z",
    fill: "#5059C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4535 4.875C15.3783 4.875 16.1279 4.11948 16.1279 3.1875C16.1279 2.25552 15.3783 1.5 14.4535 1.5C13.5287 1.5 12.7791 2.25552 12.7791 3.1875C12.7791 4.11948 13.5287 4.875 14.4535 4.875Z",
    fill: "#5059C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2442 4.87501C10.58 4.87501 11.6628 3.7837 11.6628 2.4375C11.6628 1.09131 10.58 0 9.2442 0C7.90844 0 6.82559 1.09131 6.82559 2.4375C6.82559 3.7837 7.90844 4.87501 9.2442 4.87501Z",
    fill: "#7B83EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4691 5.625H5.64716C5.26136 5.63462 4.95617 5.9573 4.96512 6.34613V10.6733C4.91124 13.0066 6.74296 14.9429 9.05814 15C11.3733 14.9429 13.205 13.0066 13.1512 10.6733V6.34613C13.1601 5.9573 12.8549 5.63462 12.4691 5.625Z",
    fill: "#7B83EB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M9.43022 5.625V11.6888C9.42837 11.9668 9.26117 12.2166 9.00603 12.3225C8.9248 12.3571 8.83749 12.375 8.74929 12.375H5.29254C5.24417 12.2513 5.19952 12.1275 5.16231 12C5.03206 11.5697 4.9656 11.1224 4.9651 10.6725V6.345C4.95615 5.95679 5.26084 5.63462 5.64603 5.625H9.43022Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.05813 5.625V12.0637C9.05812 12.1526 9.0404 12.2406 9.00603 12.3225C8.90098 12.5796 8.65311 12.7481 8.3772 12.75H5.46743C5.40417 12.6262 5.34464 12.5025 5.29254 12.375C5.24045 12.2475 5.19952 12.1275 5.16231 12C5.03206 11.5697 4.9656 11.1224 4.9651 10.6725V6.345C4.95615 5.95679 5.26084 5.63462 5.64603 5.625H9.05813Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.05815 5.625V11.3138C9.05532 11.6916 8.75211 11.9971 8.37722 12H5.16234C5.03209 11.5697 4.96563 11.1224 4.96513 10.6725V6.345C4.95618 5.95679 5.26087 5.63462 5.64606 5.625H9.05815Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.68606 5.625V11.3138C8.68322 11.6916 8.38002 11.9971 8.00513 12H5.16234C5.03209 11.5697 4.96563 11.1224 4.96513 10.6725V6.345C4.95618 5.95679 5.26087 5.63462 5.64606 5.625H8.68606Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M9.43023 3.68624V4.86749C9.36697 4.87124 9.30744 4.875 9.24418 4.875C9.18092 4.875 9.12139 4.87125 9.05813 4.86749C8.93253 4.85909 8.80797 4.83901 8.68604 4.8075C7.93255 4.62766 7.31004 4.0951 7.01162 3.375C6.96027 3.25407 6.92041 3.1285 6.89255 3H8.74929C9.12477 3.00143 9.4288 3.30783 9.43023 3.68624Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.05814 4.06124V4.8675C8.93254 4.8591 8.80798 4.83901 8.68605 4.8075C7.93255 4.62766 7.31005 4.0951 7.01163 3.375H8.37721C8.75268 3.37643 9.05671 3.68284 9.05814 4.06124Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.05814 4.06124V4.8675C8.93254 4.8591 8.80798 4.83901 8.68605 4.8075C7.93255 4.62766 7.31005 4.0951 7.01163 3.375H8.37721C8.75268 3.37643 9.05671 3.68284 9.05814 4.06124Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.68605 4.06125V4.8075C7.93255 4.62766 7.31005 4.0951 7.01163 3.375H8.00512C8.38059 3.37644 8.68462 3.68284 8.68605 4.06125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.18204 3.375H8.00399C8.38068 3.375 8.68604 3.68275 8.68604 4.06237V10.9376C8.68604 11.3172 8.38067 11.625 8.00399 11.625H1.18204C0.805358 11.625 0.5 11.3172 0.5 10.9376V4.06237C0.5 3.68275 0.805365 3.375 1.18204 3.375Z",
    fill: "url(#paint0_linear_34680_2336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38799 5.99162H5.02426V9.73413H4.15543V5.99162H2.79803V5.26562H6.38799V5.99162Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34680_2336",
    x1: 1.92208,
    y1: 2.8379,
    x2: 7.32656,
    y2: 12.1257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A62C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4D55BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3940AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34680_2336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMicrosoftTeamsLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/microsoft-teams-logo.174c8ee0aa47bd3da822f63bd62a3143.svg";